import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './fetchBaseQuery';

const api = createApi({
    reducerPath: 'geoLocationApi',
    baseQuery,
    endpoints: build => ({
        isEuCustomer: build.query<boolean, void>({
            query: () => '/api/geolocator/is-eu',
        }),
    }),
});
export const { useIsEuCustomerQuery } = api;
export default api;
